import React from 'react';
import { Award, Shield, Clock, BookOpen, GraduationCap, CheckCircle } from 'lucide-react';

const TrustBadgesBar = () => {
  const badges = [
    {
      icon: <GraduationCap size={24} />,
      title: "Oxford PGCE",
      subtitle: "Qualified Teacher"
    },
    {
      icon: <Award size={24} />,
      title: "IGCSE Examiner",
      subtitle: "Insider Knowledge"
    },
    {
      icon: <Clock size={24} />,
      title: "12+ Years",
      subtitle: "Teaching Experience"
    },
    {
      icon: <Shield size={24} />,
      title: "DBS Checked",
      subtitle: "Safe & Verified"
    },
    {
      icon: <BookOpen size={24} />,
      title: "All Exam Boards",
      subtitle: "AQA, Edexcel, OCR"
    },
    {
      icon: <CheckCircle size={24} />,
      title: "100+ Students",
      subtitle: "Helped to Excel"
    }
  ];

  return (
    <div style={{
      background: 'linear-gradient(90deg, #0F172A 0%, #1E293B 100%)',
      padding: '1.25rem 1.5rem',
      overflow: 'hidden'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
        flexWrap: 'wrap'
      }}>
        {badges.map((badge, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.5rem 0'
            }}
          >
            <div style={{ color: '#C5A059' }}>
              {badge.icon}
            </div>
            <div>
              <p style={{ 
                margin: 0, 
                color: 'white', 
                fontWeight: 700, 
                fontSize: '0.9rem',
                lineHeight: 1.2
              }}>
                {badge.title}
              </p>
              <p style={{ 
                margin: 0, 
                color: '#94A3B8', 
                fontSize: '0.75rem' 
              }}>
                {badge.subtitle}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBadgesBar;
